// @flow

import { createReducer, createAction } from 'redux-act';

import type { FullState } from '../../../types';

import type { ModalState } from './types';

export const selectModalState = (state: FullState): ModalState =>
  state.phasesModal;

export const setModalState: {
  (...mixed): { meta?: mixed, payload: mixed, type: string, ... },
  assignTo: mixed => void,
  assigned: () => boolean,
  bindTo: mixed => mixed,
  bound: () => boolean,
  dispatched: () => boolean,
  getType: () => string,
  raw: () => mixed,
  toString: () => string,
  ...
} = createAction('Set Modal State');
export const resetModalState: {
  (...mixed): { meta?: mixed, payload: mixed, type: string, ... },
  assignTo: mixed => void,
  assigned: () => boolean,
  bindTo: mixed => mixed,
  bound: () => boolean,
  dispatched: () => boolean,
  getType: () => string,
  raw: () => mixed,
  toString: () => string,
  ...
} = createAction('Reset Modal State');

const INITIAL_STATE: ModalState = {
  visible: false,
  phases: [],
  fqdn: '',
  premium: 0,
  phase: undefined,
  prices: { create: undefined, renew: undefined },
  currency: 'EUR',
  callback: undefined,
  tld: '',
  currentPage: undefined,
  totalPage: undefined,
};

const reducer: any = createReducer(
  {
    // $FlowFixMe[invalid-computed-prop]
    [setModalState]: (state: FullState, modal: ModalState) => ({
      ...state,
      ...modal,
    }),
    // $FlowFixMe[invalid-computed-prop]
    [resetModalState]: (): ModalState => INITIAL_STATE,
  },
  INITIAL_STATE,
);

export default reducer;
